import React from "react";
import css from "./CustomConfigSection.module.css";
import {FeatureExplorer,FileNavigator,FileView,NoticeView,SectionView,TextView} from "Components";
import {configfilelocation0} from "Assets";


export default function CustomConfigSection(){
    return (
        <SectionView 
            className={css.customconfigsection}
            title="custom configuration" 
            text={`
                if the above configuration is not sufficient, you can customize it and make your own.
                @to customize the default vritra configuartion, add a 
                <b>vritra.config.js</b> file in the root folder of your app.
            `}
        >
            <FileNavigator 
                files={[{content:statics.vritraconfigfile.object}]}
                preview={configfilelocation0}
            />
            <FeatureExplorer feature={{sections:[statics.docs.ignore,statics.docs.html]}}/>
            <NoticeView text={`
                The <span>vritra.config.js</span> follows the same configuration schema 
                as any typical <span>webpack.config.js</span> file.
                @the <b>definitions</b>, <b>html</b>, <b>copy</b>, <b>cypress</b> 
                and <b>ignore</b> entries are vritra-config-specific.
            `}/>
            <TextView text="The config file can export a function that returns an object as well:"/>
            <FileView content={statics.vritraconfigfile.function}/>
            <FeatureExplorer feature={{sections:[statics.docs.env]}}/>
            <NoticeView text={`
                note that not everything is customizable, some configuration is still
                required for the app to build and start as expected.
                @if the vritra.config.js file still does not suit your needs, you can
                <a 
                    href="#getstarted#availablescripts#npmrunextract" 
                    target="_self"
                >build</a> your own configuration.
            `}/>
        </SectionView>
    )
}

const statics={
    docs:{
        html:{
            title:"vritra-specific options of the html config object",
            fields:[
            {
                name:"metadata",
                type:"string",
                description:"a string added to the end of the head tag of the webviews html files",
            },
            {
                name:"withDefaultIconTag",
                type:"boolean",
                defaultValue:true,
                description:"inserts a default icon link tag in the head tag with the vritra's logo",
            },
            {
                name:"withCordovaScript",
                type:"boolean",
                defaultValue:true,
                description:"inserts the cordova script tag in the body tag",
            },
        ]},
        ignore:{fields:[{
            name:"ignore",
            type:"array",
            description:`
                specifies which node modules vritra-scripts should ignore
                @The item can be either a <span>RegExp</span>, an <a href="https://webpack.js.org/plugins/ignore-plugin/">object</a>
                or a <span>string</span> to target exact matches.
                @available since version <b>1.1.0</b>
            `,
        }]},
        env:{fields:[
            {
                name:"env",
                type:"object",
                description:`
                    configuration environment.
                    @values depend on the command used to start/build the app.
                `,
                props:[
                    {name:"id",type:`"dev"|"test"|"prod"`},
                    {name:"name",type:`"development"|"testing"|"production"`},
                    {name:"isDevEnv",type:"boolean"},
                    {name:"isTestEnv",type:"boolean"},
                    {name:"isProdEnv",type:"boolean"},
                ],
            },
            {
                name:"webpack",
                type:"function",
                description:"the webpack config function",
            },
            {
                name:"args",type:"string[]",
                description:"arguments passed to the command."
            }
        ]},
    },
    
    vritraconfigfile:{
        object:'<div><span style="color: #4ec9b0;">module</span>.<span style="color: #4ec9b0;">exports</span>={</div><div>    <span style="color: #9cdcfe;">definitions</span><span style="color: #9cdcfe;">:</span>{</div><div>        <span style="color: #6a9955;">/* New Custom Definitions */</span></div><div>    },</div><div>    <span style="color: #9cdcfe;">html</span><span style="color: #9cdcfe;">:</span>{</div><div>        <span style="color: #6a9955;">/* custom html-webpack-plugin options */</span></div><div>    },</div><div>    <span style="color: #9cdcfe;">copy</span><span style="color: #9cdcfe;">:</span>{</div><div>        <span style="color: #6a9955;">/* custom copy-webpack-plugin options */</span></div><div>    },</div><div>    <span style="color: #9cdcfe;">cypress</span><span style="color: #9cdcfe;">:</span>{</div><div>        <span style="color: #6a9955;">/* custom cypress config options */</span></div><div>    },</div><div>    <span style="color: #9cdcfe;">ignore</span><span style="color: #9cdcfe;">:</span>[</div><div>        <span style="color: #6a9955;">/* Node modules to ignore */</span></div><div>    ],</div><div>    <span style="color: #9cdcfe;">devServer</span><span style="color: #9cdcfe;">:</span>{</div><div>        <span style="color: #9cdcfe;">port</span><span style="color: #9cdcfe;">:</span><span style="color: #b5cea8;">3333</span>,<span style="color: #6a9955;">//changes test/dev server port to 3333</span></div><div>    },</div><div>    <span style="color: #9cdcfe;">plugins</span><span style="color: #9cdcfe;">:</span>[</div><div>        <span style="color: #6a9955;">/* Extra Webpack Plugins */</span></div><div>    ],</div><div>    <span style="color: #9cdcfe;">resolve</span><span style="color: #9cdcfe;">:</span>{</div><div>        <span style="color: #9cdcfe;">alias</span><span style="color: #9cdcfe;">:</span>{</div><div>            <span style="color: #6a9955;">/* New Custom Import Aliases */</span></div><div>        },</div><div>    },</div><div>    <span style="color: #6a9955;">/* Other Webpack configs */</span></div><div>};</div>',
        function:'<div><span style="color: #4ec9b0;">module</span>.<span style="color: #4ec9b0;">exports</span>=({<span style="color: #9cdcfe;">env</span>,<span style="color: #9cdcfe;">webpack</span>,<span style="color: #9cdcfe;">args</span>})<span style="color: #569cd6;">=&gt;</span>({</div><div>    <span style="color: #6a9955;">/* Webpack configs */</span></div><div>});</div>',
    },
}
